import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=2d2422aa&scoped=true&"
import script from "./Permits.vue?vue&type=script&lang=js&"
export * from "./Permits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2422aa",
  null
  
)

export default component.exports